export default { name: '@auth0/auth0-spa-js', version: '1.13.4' };
